import "./app.css";
import { createBrowserRouter, RouterProvider, Outlet, useNavigation } from "react-router";

import * as React from "react";
import ReactDOM from "react-dom/client";
import ProtectedRoute from "./ProtectedRoute";
import { AuthProvider } from "./Services/AuthContext";
import { Login } from "./Components/Login";
import { Dashboard } from "./Components/Dashboard";
import { WV } from "./Components/WV";


const router = createBrowserRouter([
  {
    path: "/",
    element: <Application />,
    children: [
      { 
        path: "/",
        Component: Login,
      },
      {
        path:"Dashboard",
        element: <ProtectedRoute><WV/></ProtectedRoute>,
        // element: <ProtectedRoute><Dashboard/></ProtectedRoute>,
        // element: <WV/>,
      }
    ]
  },
]);

const root = document.getElementById("root");

ReactDOM.createRoot(root).render(
  <AuthProvider>
    <RouterProvider router={router} />
  </AuthProvider>
);

// if (import.meta.env.PROD) {
//   console.log("loading service worker")
//   if ('serviceWorker' in navigator) {
//     navigator.serviceWorker.register("/service-worker.js");
//   }
// } else {
//   console.log("skipping service worker")
// }

console.log("loading service worker")
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register("/service-worker.js");
}

function Application(){
  return(
    <Outlet context={{ }} />
  );

}
